import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employees: [],
  },
  getters: {
    getEmployees(state) {
      return state.employees
    },
  },
  mutations: {
    SET_EMPLOYEES(state, data) {
      state.employees = data
    },
  },
  actions: {
    search({ commit }, keyword) {
      const data = JSON.stringify({ keyword })
      return axiosIns
        .post('/portal/employees', data)
        .then(response => {
          const list = response.data.data ? response.data.data : []
          commit('SET_EMPLOYEES', list)
          return list
        })
        .catch(error => {
          console.error(error)
          commit('SET_EMPLOYEES', [])
          return []
        })
    },
    clear({ commit }) {
      commit('SET_EMPLOYEES', [])
    },
  },
}
